/* eslint-disable react/no-array-index-key */
import React, { Fragment, useEffect, useState } from "react";
import { routerActions } from "connected-react-router";
import * as i18n from "util/i18n";
import useReactPrint from "pages/_components/Print/useReactToPrint";

import { actions as discountsActions } from "reducers/discounts";
import { actions as accountsActions } from "reducers/accounts";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import { Col, Row } from "react-bootstrap";
import CustomButton from "pages/_components/CustomButton/CustomButton";

// eslint-disable-next-line import/no-named-as-default
import EcheqTransactionCard, {
    EcheqTransactionHeader,
    EcheqTransactionSign,
} from "pages/_components/EcheqTransactionCard";
import Button from "pages/_components/Button";

import { useSelector, useDispatch } from "react-redux";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import GridTable from "pages/_components/GridTable/GridTable";
import { Spring, config } from "react-spring";
import I18n from "pages/_components/I18n";
import { bool, shape } from "prop-types";
import * as configUtils from "util/config";
import { getStatusTagColor } from "util/discounts";
import { ResponsiveHeader } from "pages/_components/header";
import { useTransaction } from "hooks/useTransactions";
import InfoTag from "../_components/InfoTag";

const NewDiscountFinishedTransaction = ({ transaction, isDesktop }) => {
    const dispatch = useDispatch();
    const discountTicketSignable = useSelector((_state) => _state.discount?.discountTicketSignable);
    const { componentRef, handlePrint } = useReactPrint("Detalle de la cuenta", transaction?.idTransaction);

    const [showMoreData, setShowMoreData] = useState(false);
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const account = useSelector((_state) => _state.accounts?.selectedAccount);
    const fetchingAccount = useSelector((_state) => _state.accounts?.fetching);
    const [accountLabel, setAccountLabel] = useState(null);
    const finalEcheqs = transaction?.data?.echeqs || [];
    const isLoading = !transaction?.data || fetchingAccount;
    const isBackoffice = window.self !== window.top;
    const closingHour = configUtils.get("bibank.closingHour", "18");

    const discountData = {
        idTransaction: transaction?.idTransaction || "",

        title: transaction?.activityName,

        solicitante: `${transaction?.userCreatorFirstName} ${transaction?.userCreatorLastName}`,
        montoNeto: transaction?.data?.totalEffectiveAmount || { quantity: 0, currency: "ARS" },
        montoTotal: transaction?.data?.totalAmount || { quantity: 0, currency: "ARS" },
        accountId: transaction?.data?.account?.idProduct || "",
        echeqList: transaction?.data?.echeqList || [],

        idBatch: transaction?.data?.idBatch,
        status: transaction?.data?.status,
    };

    const rate = finalEcheqs[0]?.discountEcheqExtractData?.tax?.rate;

    useEffect(() => {
        if (isBackoffice) {
            return;
        }
        if (!account?.accountType && discountData.accountId && !accountLabel) {
            dispatch(accountsActions.readAccount(discountData.accountId));
        } else if (!!account?.accountType && discountData.accountId && !accountLabel) {
            setAccountLabel(
                `${i18n.get(`productType.${account?.accountType}`, "")} ····${account?.accountNumber?.slice(-4)} ${
                    account?.accountType
                } ${i18n.get(`currency.label.${account?.currency}`, "")}` || "Error obteniendo la cuenta",
            );
        }
    }, [dispatch, account, discountData.accountId, accountLabel, setAccountLabel]);

    useEffect(
        () => () => {
            dispatch(discountsActions.cleanDiscountTicket());
        },
        [],
    );

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    const handleSignTransaction = () => {
        // const discountDetails = { ...transaction?.data?.discount, idTransaction: transaction?.idTransaction };
        // dispatch(discountsActions.setNewDiscountData(discountDetails, transaction?.data?.token));
        dispatch(routerActions.push("/discounts/summaryForm"));
    };

    const handleDownload = () => {
        handlePrint();
    };

    const formatTransactionTransfer = (data, idTransaction) => ({ ...data, idTransaction });

    const { status } = useTransaction(
        `/lotPayments/newPayment/confirm`,
        discountsActions.summaryThirdPay,
        discountsActions.cleanThirdPartiesTicket,
        formatTransactionTransfer,
    );

    const { isFlowComplete } = status;
    const backLinkTo = isFlowComplete ? "/transactions" : "";

    return (
        <Fragment>
            <Notification scopeToShow="discounts" />
            <MainContainer showLoader={isLoading} ref={componentRef}>
                <EcheqTransactionCard transaction={transaction}>
                    {!isBackoffice && <ResponsiveHeader defaultTitle="Descuento de echeq" backLinkTo={backLinkTo} />}
                    <EcheqTransactionHeader title={discountData.title} subTitle={i18n.get("", "Operación Aprobada")} />
                    <div className="ticket__wrapper">
                        <div className="ticket__header" />
                        <div className="ticket__body refills-transaction">
                            <div className="ticket-header-info two-col-centered" style={{ gap: "25px" }}>
                                <CustomData
                                    titleText={i18n.get("", "Solicitante")}
                                    valueText={discountData.solicitante}
                                />
                                <CustomData
                                    dataClass="amount tag tag-echeq-character"
                                    titleText={`${i18n.get(
                                        "detail.discounts.totalAmountToCredit",
                                        "Monto a acreditar",
                                    )}`}
                                    valueText={discountData.montoNeto.quantity}
                                    valueTextType={discountData.montoNeto.currency}
                                />
                            </div>
                            <div className="view-more-data-button" id="element-to-ignore">
                                <div className="ticket__divider inside-ticket__body">
                                    <div className="ticket__notch ticket__notch--left"> </div>
                                    <div className="ticket__notch ticket__notch--right"> </div>
                                </div>
                                <Button
                                    aria-expanded={showMoreData ? "true" : "false"}
                                    className="btn btn-link open-filters d-flex margin-cero-auto"
                                    label={buttonLabel}
                                    onClick={handleSeeMoreData}
                                    image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                                    block={false}
                                />
                                <Spring
                                    config={config.stiff}
                                    from={{ height: 0 }}
                                    to={{
                                        height: showMoreData ? "auto" : 0,
                                        overflow: "hidden",
                                    }}>
                                    {(styles) => (
                                        <div className="form-group" style={styles}>
                                            <div className="form-group-control-list">
                                                <I18n id="creditBill.aditionalData.label" component="h2" />
                                                <div
                                                    className={`view-more-data ${
                                                        showMoreData ? "expand " : "collapse"
                                                    } pt-4 ticket-section four-cols`}>
                                                    <CustomData
                                                        titleText="detail.discounts.creditAccount"
                                                        titleTextType="I18N"
                                                        valueText={accountLabel}
                                                    />
                                                    <CustomData
                                                        titleText={i18n.get(
                                                            "detail.discounts.amount.negotiated",
                                                            "Monto a negociar",
                                                        )}
                                                        valueText={discountData.montoTotal.quantity}
                                                        valueTextType={discountData.montoTotal.currency}
                                                    />
                                                    <CustomData
                                                        titleText="echeq.request.amount.label"
                                                        titleTextType="I18N"
                                                        valueText={finalEcheqs.length}
                                                    />
                                                    <CustomData
                                                        titleText="detail.discounts.rate"
                                                        titleTextType="I18N"
                                                        valueText={`${rate} %`}
                                                    />
                                                </div>
                                            </div>
                                            <div className="ticket__divider inside-ticket__body">
                                                <div className="ticket__notch ticket__notch--left"> </div>
                                                <div className="ticket__notch ticket__notch--right"> </div>
                                            </div>
                                        </div>
                                    )}
                                </Spring>
                            </div>
                            <div
                                className={`view-more-data view-discounts-echeq ${
                                    showMoreData ? "expand " : "collapse"
                                }`}>
                                <I18n id="documentBatch" component="h2" />
                                <GridTable>
                                    {isDesktop && (
                                        <GridTable.Container columns={5} rows={1} className="received-from">
                                            <GridTable.Data columnStart={1} rowStart={1}>
                                                <CustomText
                                                    className="title-discounts"
                                                    text={i18n.get("", "Recibido de")}
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={2} rowStart={1}>
                                                <CustomText
                                                    className="title-discounts"
                                                    text={i18n.get("", "Nº Echeq")}
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={3} rowStart={1}>
                                                <CustomText
                                                    className="title-discounts"
                                                    text={i18n.get("echeq.transaction.emision.date")}
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={4} rowStart={1}>
                                                <CustomText
                                                    className="title-discounts"
                                                    text={i18n.get("echeqs.emit.date.label")}
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={5} rowStart={1}>
                                                <CustomText
                                                    className="title-discounts align-items-center"
                                                    text={i18n.get("", "Monto")}
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={6} rowStart={1}>
                                                <CustomText
                                                    className="title-discounts align-items-center"
                                                    text={i18n.get("", "Estado")}
                                                />
                                            </GridTable.Data>
                                        </GridTable.Container>
                                    )}
                                    <Spring
                                        config={config.stiff}
                                        from={{ height: 0 }}
                                        to={{
                                            height: finalEcheqs.length ? "auto" : 0,
                                            overflow: "hidden",
                                        }}>
                                        {(styles) => (
                                            <div className="form-group" style={styles}>
                                                <div className="form-group-control-list">
                                                    {finalEcheqs.map((echeq, index) => (
                                                        <GridTable.Container
                                                            columns={5}
                                                            rows={1}
                                                            className="received-from data-echeq"
                                                            key={index}>
                                                            <GridTable.Data
                                                                columnStart={1}
                                                                rowStart={1}
                                                                key={index}
                                                                flexDirection="column">
                                                                {isDesktop ? (
                                                                    <>
                                                                        <CustomText
                                                                            text={`CUIT ${echeq.emisor_cuit}`}
                                                                        />
                                                                        <CustomText
                                                                            text={`${echeq.emisor_razon_social}`}
                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <CustomData
                                                                        titleText="detail.discounts.recibedTo"
                                                                        titleTextType="I18N"
                                                                        valueText={
                                                                            <>
                                                                                <CustomText
                                                                                    text={`CUIT ${echeq.emisor_cuit}`}
                                                                                />
                                                                                <br />
                                                                                <CustomText
                                                                                    text={`${echeq.emisor_razon_social}`}
                                                                                />
                                                                            </>
                                                                        }
                                                                    />
                                                                )}
                                                            </GridTable.Data>
                                                            <GridTable.Data columnStart={2} rowStart={1}>
                                                                {isDesktop ? (
                                                                    <CustomText text={echeq.cheque_numero} />
                                                                ) : (
                                                                    <CustomData
                                                                        titleText="detail.discounts.echek.id"
                                                                        titleTextType="I18N"
                                                                        valueText={echeq.cheque_numero}
                                                                    />
                                                                )}
                                                            </GridTable.Data>
                                                            <GridTable.Data columnStart={3} rowStart={1}>
                                                                {isDesktop ? (
                                                                    <CustomText
                                                                        text={echeq.fecha_emision}
                                                                        textType="DATE"
                                                                    />
                                                                ) : (
                                                                    <CustomData
                                                                        titleText="detail.discounts.emitter"
                                                                        titleTextType="I18N"
                                                                        valueText={echeq.fecha_emision}
                                                                        textType="DATE"
                                                                    />
                                                                )}
                                                            </GridTable.Data>
                                                            <GridTable.Data columnStart={4} rowStart={1}>
                                                                {isDesktop ? (
                                                                    <CustomText
                                                                        text={echeq.fecha_pago}
                                                                        textType="DATE"
                                                                    />
                                                                ) : (
                                                                    <CustomData
                                                                        titleText="echeqs.emit.date.label"
                                                                        titleTextType="I18N"
                                                                        valueText={echeq.fecha_pago}
                                                                        textType="DATE"
                                                                    />
                                                                )}
                                                            </GridTable.Data>
                                                            <GridTable.Data columnStart={5} rowStart={1}>
                                                                {isDesktop ? (
                                                                    <CustomText
                                                                        text={echeq.monto}
                                                                        textType={echeq.emisor_moneda}
                                                                    />
                                                                ) : (
                                                                    <CustomData
                                                                        titleText="detail.discounts.amount"
                                                                        titleTextType="I18N"
                                                                        valueText={echeq.monto}
                                                                        textType={echeq.emisor_moneda}
                                                                    />
                                                                )}
                                                            </GridTable.Data>
                                                            <GridTable.Data columnStart={6} rowStart={1}>
                                                                <InfoTag
                                                                    type="info"
                                                                    message={i18n.get(
                                                                        `transaction.discount.status.FINISHED.${discountData?.status}`,
                                                                    )}
                                                                    tagBackground={getStatusTagColor(
                                                                        discountData?.status,
                                                                    )}
                                                                />
                                                            </GridTable.Data>
                                                            {index !== finalEcheqs.length - 1 && !isDesktop && (
                                                                <div className="ticket__divider inside-ticket__body">
                                                                    <div className="ticket__notch ticket__notch--left" />
                                                                    <div className="ticket__notch ticket__notch--right" />
                                                                </div>
                                                            )}
                                                        </GridTable.Container>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </Spring>
                                </GridTable>
                            </div>
                            <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                                <EcheqTransactionSign showSignatures />
                            </div>
                        </div>
                        <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                    </div>
                </EcheqTransactionCard>

                <div className="box info border">
                    <CustomData
                        keepSpaceIfNoValue={false}
                        icon="images/figma/icon/info.svg"
                        titleText={i18n.get(
                            "",
                            `Recordá que las operaciones para descontar tus Echeq se deberán realizar los 
                            días hábiles desde las 10:00 hasta las ${closingHour}:00 hs`,
                        )}
                    />
                </div>

                {/* <div className="discounts-echeq-simulation__rate">
                    <CustomText
                        text={`* ${i18n.get(
                            "discounts.amountToCredit.disclaimer",
                            "Monto a acreditar sujeto a impuesto de sellos e IIBB.",
                        )}`}
                    />
                </div> */}

                {!isBackoffice && (
                    <Row className="form-actions">
                        <Col xs={12} md={4} mdOffset={2}>
                            <CustomButton
                                func={() => dispatch(routerActions.push("/desktop"))}
                                text="forms.transaction.ticket.actions.backToHome"
                                textType="I18N"
                                className="btn btn-outline"
                            />
                        </Col>
                        {discountTicketSignable ? (
                            <Col xs={12} md={4}>
                                <CustomButton
                                    func={handleSignTransaction}
                                    text="forms.signTransaction.link"
                                    textType="I18N"
                                    className="btn btn-primary"
                                />
                            </Col>
                        ) : (
                            <Col xs={12} md={4}>
                                <Button
                                    className="btn-primary"
                                    image="images/figma/icon/download.svg"
                                    label="global.download"
                                    onClick={handleDownload}
                                    block
                                />
                            </Col>
                        )}
                    </Row>
                )}
            </MainContainer>
        </Fragment>
    );
};

NewDiscountFinishedTransaction.propTypes = {
    transaction: shape({}).isRequired,
    isDesktop: bool.isRequired,
};

export default NewDiscountFinishedTransaction;
